import { html, TemplateResult } from 'lit';
import { msg } from '@lit/localize';

export interface PriceBoxDefaultTemplateOptions {
    componentTitle: string;
    operatorName: string;
    phoneNumber: string;
    roundtripTypes: string;
    startDestination: string;
    startPoint: string;
    languages: string;
    groupSize: string;
    bestTravelTime: string;
    roundtripKey: string;
    price: string;
    durationString: string;
    onButtonClick: (event: PointerEvent) => void;
    onPhoneClick: (event: PointerEvent) => void;
    loading?: boolean;
}

function renderRoundtripDataItem(label: string, value: string, icon: string): TemplateResult {
    return html`<der-ui-icon-label icon="${icon}" label="${label}" value="${value}"></der-ui-icon-label>`;
}

function renderRoundtripData(
    options: Pick<
        PriceBoxDefaultTemplateOptions,
        | 'roundtripTypes'
        | 'startDestination'
        | 'startPoint'
        | 'languages'
        | 'groupSize'
        | 'bestTravelTime'
        | 'durationString'
        | 'roundtripKey'
    >
): TemplateResult {
    const routeText = options.startDestination;

    return html`
        <div class="m-price-box__roundtrip-data">
            ${options.roundtripTypes
                ? renderRoundtripDataItem(msg('roundtripTypeLabel'), options.roundtripTypes, 'systemExplore')
                : html``}
            ${options.groupSize
                ? renderRoundtripDataItem(msg('groupSizeLabel'), options.groupSize, 'systemGroup')
                : html``}
            ${routeText
                ? renderRoundtripDataItem(msg('startDestinationLabel'), options.startDestination, 'systemRoute')
                : html``}
            ${options.startPoint
                ? renderRoundtripDataItem(msg('startPointLabel'), options.startPoint, 'systemPin')
                : html``}
            ${options.durationString
                ? renderRoundtripDataItem(msg('durationLabel'), options.durationString, 'systemClock')
                : html``}
            ${options.languages
                ? renderRoundtripDataItem(msg('languagesLabel'), options.languages, 'systemLanguageGlobe')
                : html``}
            ${options.bestTravelTime
                ? renderRoundtripDataItem(msg('bestTravelTimeLabel'), options.bestTravelTime, 'systemSun')
                : html``}
        </div>
    `;
}

export function renderPriceBoxDefault(options: PriceBoxDefaultTemplateOptions): TemplateResult {
    return html`
        <div class="m-price-box">
            <div class="m-price-box__roundtrip">
                ${options.componentTitle
                    ? html`<div class="m-price-box__roundtrip-title">${options.componentTitle}</div>`
                    : html``}
            </div>
            <div class="m-price-box__button">
                <der-ui-button @click=${options.onButtonClick}>${msg('ctaText')}</der-ui-button>
                ${options.phoneNumber
                    ? html`<der-ui-button
                          @click=${options.onPhoneClick}
                          variant="secondary"
                          url="tel:${options.phoneNumber}"
                          >${options.phoneNumber}</der-ui-button
                      >`
                    : html``}
            </div>
            ${options.operatorName
                ? html`<div class="m-price-box__information">${msg('operatorInfo')} ${options.operatorName}</div>`
                : html``}
            <div class="m-price-box__price-info-wrapper">
                <div class="m-price-box__price">
                    <div class="m-price-box__amount">
                        <span class="m-price-box__label">${msg('fromPrice')}</span>
                        ${options.loading
                            ? html`<b
                                  class="der-tm-offer-panel-skeleton-line der-tm-offer-panel-skeleton-line--w-5"
                              ></b>`
                            : options.price}
                    </div>
                    <div class="m-price-box__per-person">${msg('perPersonLabel')}</div>
                </div>
                ${renderRoundtripData(options)}
            </div>
        </div>
    `;
}
